import MetaTags from 'react-meta-tags';
import React, { useEffect, useState } from 'react';

import { Row, Col, Alert, Container, Spinner } from 'reactstrap';

//redux
import { useSelector, useDispatch } from 'react-redux';

import { Link, useHistory } from 'react-router-dom';
import Turnstile from 'react-turnstile';

// availity-reactstrap-validation
import { AvForm, AvField } from 'availity-reactstrap-validation';

// actions
import { LoginUser } from '../../store/actions';

// import images
import logo from '../../assets/images/logo-sm.svg';
import defaultAvatar from '../../assets/images/users/avatar-1.jpg';
import toast, { Toaster } from 'react-hot-toast';
import CarouselPage from './CarouselPage';

const LockScreen = () => {
  const SITE_KEY = '0x4AAAAAAAEdKjlfBcJ0OZIu';
  const dispatch = useDispatch();
  const history = useHistory();
  const { users = [] } = useSelector((state) => state.user);

  const [errorMsg, setErrorMessage] = useState();
  const [inputData, setInputData] = useState({});
  const [unlockClick, setUnlockClick] = useState(false);
  const [isCapchaVerified, setIsCapchaVerified] = useState(false);
  const [stsLoad, setStatusLoad] = useState(false);
  const [token, setToken] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Logged-in user details from localStorage
  let userName = '';
  let userEmail = '';
  let userImage = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      userName = userObj?.user_name;
      userEmail = userObj?.user_email;
      userImage = userObj?.image;
    }
  }

  const getDefaultDashboard = () => {
    try {
      const authUser = JSON.parse(localStorage.getItem('authUser'));
      if (authUser?.role_id === '51') {
        return '/service-orders/dashboard';
      }
      if (String(authUser?.role_id) === '58') {
        return '/orders?status=All&search=&page=0&limit=10';
      }
    } catch (e) {
      // ignore parse errors and fall back to the default dashboard
    }
    return '/dashboard';
  };

  const handleValidSubmit = (events, values) => {
    setErrorMessage('');
    setInputData(values);
    setUnlockClick(true);
  };

  const UnlockFunc = async () => {
    setStatusLoad(true);
    await LoginUser({
      params: {
        username: userEmail || userName,
        password: inputData?.password,
        token: token,
      },
      dispatch,
    });
  };

  useEffect(() => {
    if (unlockClick === true && isCapchaVerified) {
      UnlockFunc();
    }
  }, [inputData, unlockClick]);

  useEffect(() => {
    if (unlockClick !== true) return;
    setStatusLoad(false);
    if (users?.code === 100) {
      setUnlockClick(false);
      history.push(getDefaultDashboard());
    } else if (users?.message) {
      setErrorMessage(users?.message);
      setUnlockClick(false);
    }
  }, [users]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>Lock Screen | Danube Home OMS Dashboard</title>
      </MetaTags>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to="/dashboard" className="d-block auth-logo">
                        <img src={logo} alt="" height="23" />{' '}
                        <span className="logo-txt">Danube Home OMS</span>
                      </Link>
                    </div>

                    <div className="auth-content" style={{ marginTop: '15%' }}>
                      <div className="text-center">
                        <div className="avatar-lg mx-auto mb-3">
                          <img
                            src={userImage || defaultAvatar}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = defaultAvatar;
                            }}
                            alt="profile"
                            className="img-thumbnail rounded-circle h-100 w-100"
                            style={{ objectFit: 'cover' }}
                          />
                        </div>
                        <h5 className="mb-0">{userName || 'Welcome Back'}</h5>
                        <p className="text-muted mt-2">
                          Enter your password to unlock the screen.
                        </p>
                      </div>
                      <AvForm
                        className="custom-form mt-4 pt-2"
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v);
                        }}
                      >
                        {errorMsg ? (
                          <Alert color="danger">{errorMsg}</Alert>
                        ) : null}

                        <div className="mb-3">
                          <label className="form-label">Password</label>
                          <div className="position-relative">
                            <AvField
                              name="password"
                              type={showPassword ? 'text' : 'password'}
                              className="form-control"
                              required
                              placeholder="Enter Password"
                            />
                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              className="btn btn-link position-absolute text-decoration-none text-muted"
                              style={{
                                top: 0,
                                right: 0,
                                height: '38px',
                                zIndex: 5,
                              }}
                              tabIndex={-1}
                              aria-label={
                                showPassword ? 'Hide password' : 'Show password'
                              }
                            >
                              <i
                                className={
                                  showPassword
                                    ? 'mdi mdi-eye-off'
                                    : 'mdi mdi-eye-outline'
                                }
                              />
                            </button>
                          </div>
                        </div>

                        <div className="row mb-4">
                          <Turnstile
                            sitekey={SITE_KEY}
                            onVerify={(t) => {
                              setIsCapchaVerified(true);
                              setToken(t);
                            }}
                            onError={() => {
                              setIsCapchaVerified(false);
                            }}
                            onExpire={() => {
                              setIsCapchaVerified(false);
                            }}
                            onTimeout={() => {
                              setIsCapchaVerified(false);
                            }}
                          />
                        </div>

                        <div className="mb-3">
                          <button
                            className="btn btn-dark w-100 waves-effect waves-light"
                            type="submit"
                          >
                            {stsLoad === true && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            )}{' '}
                            Unlock
                          </button>
                        </div>
                      </AvForm>

                      <div className="mt-5 text-center">
                        <p className="text-muted mb-0">
                          Not you ?{' '}
                          <a href="/logout" className="text-dark fw-semibold">
                            {' '}
                            Sign Out{' '}
                          </a>
                        </p>
                      </div>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} oms.danubehome.com. Crafted
                        with <i className="mdi mdi-heart text-danger"></i> by
                        danubehome.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default LockScreen;
